import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchGrammarTopics, deleteGrammarTopic } from "./adminGrammarService";
import GrammarTopicForm from "./GrammarTopicForm";
import "../../blog/tongueTwister.css";

const AdminGrammarTopicPage = () => {
 const [items, setItems] = useState([]);
 const [editing, setEditing] = useState(null);
 const [showForm, setShowForm] = useState(false);
 const [loading, setLoading] = useState(false);
 const [search, setSearch] = useState("");
 const [page, setPage] = useState(0);
 const [totalPages, setTotalPages] = useState(0);
 const navigate = useNavigate();

 useEffect(() => { loadItems(); }, [page, search]);

 const loadItems = async () => {
 setLoading(true);
 const res = await fetchGrammarTopics({ page, size: 20, search: search || undefined });
 if (res.status === 200 && res.data) {
 const list = res.data.content || [];
 setItems(list);
 setTotalPages(res.data.totalPages || 0);
 } else {
 setItems([]);
 alert(res.message || "Failed to load");
 }
 setLoading(false);
 };

 const handleDelete = async (id) => {
 if (!window.confirm("Delete this grammar topic?")) return;
 const res = await deleteGrammarTopic(id);
 if (res.status === 200 || res.status === 204) {
 loadItems();
 } else {
 alert(res.message);
 }
 };

 const onSaved = () => {
 setShowForm(false);
 setEditing(null);
 loadItems();
 };

 return (
 <div className="admin-container">
 <div className="admin-header">
 <h2>Grammar Topic Management</h2>
 <button onClick={() => { setEditing(null); setShowForm(true); }}>+ New Topic</button>
 </div>

 {showForm && (
 <GrammarTopicForm topic={editing} onSaved={onSaved} onCancel={() => setShowForm(false)} />
 )}

 <input
 type="text"
 placeholder="Search grammar topics..."
 value={search}
 onChange={(e) => { setPage(0); setSearch(e.target.value); }}
 />

 {loading ? (
 <p>Loading...</p>
 ) : (
 <table className="announcement-table">
 <thead>
 <tr>
 <th>Icon</th>
 <th>Title</th>
 <th>Description</th>
 <th>Sort Order</th>
 <th>Sub Topics</th>
 <th>Actions</th>
 </tr>
 </thead>
 <tbody>
 {items.length === 0 ? (
 <tr><td colSpan="6">No grammar topics found</td></tr>
 ) : (
 items.map((t) => (
 <tr key={t.id}>
 <td style={{ fontSize: "1.5rem", textAlign: "center" }}>{t.icon || "—"}</td>
 <td>
 <span
 style={{ color: "#019095", cursor: "pointer", fontWeight: 600 }}
 onClick={() => navigate(`/admin/content/grammar/${t.id}`)}
 >
 {t.title}
 </span>
 </td>
 <td>{t.description}</td>
 <td style={{ textAlign: "center" }}>{t.sortOrder ?? "—"}</td>
 <td style={{ textAlign: "center" }}>{t.subTopicCount || 0}</td>
 <td>
 <button onClick={() => { setEditing(t); setShowForm(true); }}>Edit</button>
 <button className="delete-btn" onClick={() => handleDelete(t.id)}>Delete</button>
 </td>
 </tr>
 ))
 )}
 </tbody>
 </table>
 )}

 {totalPages > 1 && (
 <div style={{ marginTop: 20 }}>
 <button disabled={page === 0} onClick={() => setPage(page - 1)}>Prev</button>
 <span style={{ margin: "0 10px" }}>Page {page + 1} / {totalPages}</span>
 <button disabled={page + 1 >= totalPages} onClick={() => setPage(page + 1)}>Next</button>
 </div>
 )}
 </div>
 );
};

export default AdminGrammarTopicPage;
